// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const certificateRecordCheckSchema = z.object({
  "provider": z.enum(["certspotter"]),
  "enabled": z.boolean(),
  "key_saved": z.boolean(),
  "key_hint": z.string().optional(),
  "updated_at": z.string().datetime({ offset: true }).optional(),
  "updated_by": z.string().optional(),
  "checked_at": z.string().datetime({ offset: true }).optional(),
  "last_error": z.string().optional(),
  "open_findings": z.number().int()
});

export const certificateRecordCheckUpdateSchema = z.object({
  "enabled": z.boolean(),
  "api_key": z.string().min(8).max(512).optional()
}).strict();
